import { render, staticRenderFns } from "./ConflictModal.vue?vue&type=template&id=5228aaae&scoped=true"
import script from "./ConflictModal.vue?vue&type=script&lang=js"
export * from "./ConflictModal.vue?vue&type=script&lang=js"
import style0 from "./ConflictModal.vue?vue&type=style&index=0&id=5228aaae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5228aaae",
  null
  
)

export default component.exports